module.exports = __webpack_public_path__ + "static/media/communities.45477828.jpg";